import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthDataService } from '../auth-data.service';

@Component({
  selector: 'app-token-expired',
  templateUrl: './token-expired.component.html',
  styleUrls: ['./token-expired.component.scss']
})
export class TokenExpiredComponent implements OnInit {
  form!: UntypedFormGroup;
  isLoading = false;
  success = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthDataService,
    private snackBar: MatSnackBar
  ) {
    this.createForm();
  }

  ngOnInit() {}

  createForm() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  requestNewToken() {
    if (this.form.invalid) {
      return;
    }

    this.isLoading = true;
    const email = this.form.controls['email'].value;

    this.authService.requestNewActivationToken(email).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.success = true;
          this.snackBar.open('Ein neuer Aktivierungslink wurde an Ihre E-Mail-Adresse gesendet.', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 5000,
          });
        } else {
          this.snackBar.open(response.error || 'Fehler beim Anfordern des Aktivierungslinks', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
          });
        }
        this.isLoading = false;
      },
      error: (error: any) => {
        this.snackBar.open(error.error?.error || 'Fehler beim Anfordern des Aktivierungslinks', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
        });
        this.isLoading = false;
      }
    });
  }

  goToLogin() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}



